import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const notUiNodeSpec: UiNodeSpec<'not'> = {
    requiredSockets: 'all',
    cfg: () => ({ controlValues: {}, id: getUID(), kind: 'not', disabled: false }),
    controls: () => ({}),
    inputs: () => ({ input: { socket: 'boolean', label: 'Input' } }),
    kindLabel: 'Boolean NOT',
    nodeCategory: 'boolean',
    outputs: () => ({ output: { socket: 'boolean', label: 'Output' } }),
    validator: () => true,
};
